import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'imagePath',
})
export class ImagePathPipe implements PipeTransform {
    transform(imageName: string): string {
        let imagePathSrc: string;
        imagePathSrc = '/assets/images/';
        return imagePathSrc + imageName;
    }
}
